document.addEventListener('alpine:init', () => {
  Alpine.store('utilities', {
    isMobile,
    getScript,
    getElsFromHtmlString,
    getElFromHtmlString,
    removeSectionWrapper,
    scrollIntoViewWithinEl,
    findScrollContainer,
    getDefaultAlpineMorphLifecycleHooks
  });

  function isMobile() {
    return !window.matchMedia('(width >= 64rem)').matches;
  };

  function getElsFromHtmlString(htmlString, selector) {
    var parser = new DOMParser();
    var parserDocument = parser.parseFromString(htmlString, 'text/html');

    return parserDocument.querySelectorAll(selector);
  };

  function getElFromHtmlString(htmlString, selector) {
    return getElsFromHtmlString(htmlString, selector)[0];
  };

  function removeSectionWrapper(htmlString) {
    var parser = new DOMParser();
    var parserDocument = parser.parseFromString(htmlString, 'text/html');

    return parserDocument.body.firstElementChild.innerHTML;
  };

  function getScript(source, callback) {
    var script = document.createElement('script');
    var prior = document.getElementsByTagName('script')[0];

    script.onload = script.onreadystatechange = (_, isAbort) => {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = script.onreadystatechange = null;
        script = undefined;
        if (!isAbort) if (callback) callback();
      }
    };

    script.src = source;
    prior.parentNode.insertBefore(script, prior);
  };

  function scrollIntoViewWithinEl(el, behavior) {
    var scrollContainer = findScrollContainer(el);

    scrollContainer.scroll({ left: el.offsetLeft, behavior });
  };

  function findScrollContainer(el) {
    if (!el) {
      return undefined;
    }

    var parent = el.parentElement;

    while (parent) {
      var { overflow } = window.getComputedStyle(parent);

      if (overflow.split(' ').every(o => o === 'auto' || o === 'scroll')) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return document.documentElement;
  };

  function getDefaultAlpineMorphLifecycleHooks() {
    return {
      updating(el, toEl, childrenOnly, skip) {
        if (el.hasAttribute && el.hasAttribute('data-alpine-morph-full-replace')) {
          skip();
          el.replaceWith(toEl);
        }
      }
    };
  };
});
